type Props = {
  height: string;
  stroke: string;
  width: string;
};

export default function CloseIcon({ height, stroke, width }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 1.5 22.5 22.5 M22.5 1.5 1.5 22.5"
        stroke={stroke}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
